import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';
import makeStyles from '@mui/styles/makeStyles';
import { CARD_BRAND_LIST } from '../Constants';
import { PaymentMethod } from '../../../../models';

const useStyles = makeStyles(theme => ({
  savedCard: {
    marginBottom: theme.spacing(2),
    borderBottom: '1px solid #DCDFE6',
    paddingBottom: theme.spacing(3),
  },
  savedCardLogo: {
    height: theme.spacing(8.5),
    display: 'block',
    borderRadius: theme.spacing(0.5),
    marginRight: theme.spacing(1.5),
  },
  savedCardInfo: {
    marginRight: theme.spacing(1.5),
  },
}));
export const CurrentPaymentCard = (
  { currentCard }: { currentCard: PaymentMethod },
) => {
  const classes = useStyles();
  const getSavedPaymentCardLogo = () => {
    const cardBrand = CARD_BRAND_LIST.find(it => it.brand === currentCard?.brand?.toLowerCase());
    return cardBrand ? (
      <img
        src={cardBrand.src}
        className={classes.savedCardLogo}
        alt="current-logo"
      />
    ) : null;
  };

  return (
    <Grid container alignItems="center" className={classes.savedCard}>
      {getSavedPaymentCardLogo()}
      <Grid item className={classes.savedCardInfo}>
        <Typography variant="h3" sx={{ textTransform: 'capitalize' }}>
          {`${currentCard.brand} **** ${currentCard.last4}`}
        </Typography>
        <Typography variant="subtitle2">
          {`Expires ${currentCard.expiration}`}
        </Typography>
      </Grid>
    </Grid>
  );
};
